class SimpleHash {
  private buffer: string = '';
  constructor(private algorithm: string = 'sha256') {}

  update(data: any): this {
    if (typeof data === 'string') {
      this.buffer += data;
    } else if (data instanceof Uint8Array || data instanceof ArrayBuffer) {
      this.buffer += new TextDecoder().decode(data);
    } else {
      this.buffer += String(data);
    }
    return this;
  }

  digest(encoding: 'hex' | 'binary' | 'base64' = 'hex'): any {
    let hash = 2166136261;
    for (let i = 0; i < this.buffer.length; i++) {
      hash ^= this.buffer.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    const hex = (hash >>> 0).toString(16).padStart(8, '0').repeat(8).slice(0, 64);
    if (encoding === 'base64') return btoa(hex);
    if (encoding === 'binary') return new TextEncoder().encode(hex);
    return hex;
  }
}

export function createHash(algorithm: string) {
  return new SimpleHash(algorithm);
}

export function createHmac(algorithm: string, _key: unknown) {
  return new SimpleHash(algorithm);
}

export function randomBytes(size: number): Uint8Array {
  const buf = new Uint8Array(size);
  if (typeof globalThis.crypto !== 'undefined' && globalThis.crypto.getRandomValues) {
    globalThis.crypto.getRandomValues(buf);
  }
  return buf;
}

export function randomUUID(): string {
  if (typeof globalThis.crypto !== 'undefined' && globalThis.crypto.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function timingSafeEqual(a: Uint8Array, b: Uint8Array): boolean {
  if (a.length !== b.length) return false;
  let out = 0;
  for (let i = 0; i < a.length; i++) out |= a[i] ^ b[i];
  return out === 0;
}

export const webcrypto = globalThis.crypto;
export const subtle = globalThis.crypto?.subtle;

export default {
  createHash,
  createHmac,
  randomBytes,
  randomUUID,
  timingSafeEqual,
  webcrypto,
  subtle,
  getRandomValues: (arr: Uint8Array) => globalThis.crypto?.getRandomValues(arr) || arr,
};
